module.exports = __webpack_public_path__ + "img/img_investment.1bd69a92.jpg";